import { FirebaseError } from 'firebase/app';

export const ACCOUNT_PAUSED_MESSAGE =
  'Your VoteBeats account has been paused. Check your email, or reply to any VoteBeats email if you have questions.';

export function isAccountPausedError(error: unknown): boolean {
  return error instanceof FirebaseError && error.code === 'auth/user-disabled';
}
